import { useNavigate } from 'react-router-dom';
import { Images } from '../../../utils/imageConstants';
import type { IMyTeam } from '../types/myTeam';

interface TeamCardProps {
  team: IMyTeam;
}

function TeamCard({ team }: TeamCardProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/my-team/${team.teamId}`, { state: { team } });
  };

  return (
    <div className="myteam-team-card" onClick={handleClick} onKeyDown={(e) => e.key === 'Enter' && handleClick()} role="button" tabIndex={0}>
      <img
        src={team.teamLogo || Images.team_logo}
        alt={team.teamName}
        className="myteam-team-card-logo"
      />
      <div className="myteam-team-card-info">
        <span className="myteam-team-card-name">{team.teamName}</span>
        <span className="myteam-team-card-id">CricCenter Team ID : <span className="myteam-team-card-id-value">{team.cricCenterTeamId}</span></span>
      </div>
    </div>
  );
}

export default TeamCard;
